<template>
    <v-layout row wrap id="httpError">
        <v-flex xs10 offset-xs1 lg8 offset-lg2>

            <p class="body-1 grey--text text--darken-1 mt-4">{{ `${errorCode} - ${errorCodeLabel}` }}</p>
            <v-card>
                <v-card-text>
                    <v-form>
                        <v-layout row class="row--short">
                            <v-flex xs3 lg2>
                                <label class="form-label">{{ $t('label.message') }}</label>
                            </v-flex>
                            <v-flex xs9 lg10>
                                <span class="form-value">
                                    <pre>{{ message }}</pre>
                                </span>
                            </v-flex>
                        </v-layout>
                        <v-layout row class="row--short">
                            <v-flex xs3 lg2>
                                <label class="form-label">Login</label>
                            </v-flex>
                            <v-flex xs9 lg10>
                                <span class="form-value">
                                    <pre>{{ profile.login }}</pre>
                                </span>
                            </v-flex>
                        </v-layout>
                        <v-layout row class="row--short">
                            <v-flex xs3 lg2>
                                <label class="form-label">{{ $t('label.auditSession') }}</label>
                            </v-flex>
                            <v-flex xs9 lg10>
                                <span class="form-value">
                                    <pre>{{ profile.auditId }}</pre>
                                </span>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs3 lg2>
                                <label class="form-label">{{ $t('label.token') }}</label>
                            </v-flex>
                            <v-flex xs9 lg10>
                                <span class="form-value">
                                    <pre>{{ profile.token }}</pre>
                                </span>
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<style lang="stylus">
#httpError pre {
    word-wrap: break-word;
    white-space: pre-wrap;
}
</style>


<script>
export default {
    computed: {
        errorCode() {
            return this.$route.params.id;
        },
        errorCodeLabel() {
            return this.$t(`type.httpError.${this.errorCode}`);
        },
        message() {
            return this.$store.getters.apiEvent.message;
        },
        profile() {
            return this.$store.getters.profile;
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/shared/HttpError.vue